var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactBoxWrap"},[_c('div',{staticClass:"midSvg"},[_c('IconBase',{attrs:{"viewBox":'0 0 22.001 18'}},[_c('mailTo')],1)],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"midDesWrap"},[_c('a',{attrs:{"href":"mailto:info@msk.finmoll.com"}},[_vm._v("info@msk.finmoll.com")]),_c('p',[_vm._v("c 9:00 до 21:00, без выходных")])])
}]

export { render, staticRenderFns }